import React from 'react'

import { Input } from '@frame/ui-primitives/input'

const fields = [
  { name: 'normal', label: 'Normal', tagType: 'recommended' },
  {
    name: 'error',
    label: 'Error',
    tagType: 'required',
    error: 'This field is required',
  },
  {
    name: 'warning',
    label: 'Warning',
    tagType: 'recommended',
    warning: 'This field is recommended',
  },
] as const

type fieldNames = (typeof fields)[number]['name']

export default function Fields() {
  const [form, setForm] = React.useState<{ [k in fieldNames]: string }>({
    normal: '',
    error: '',
    warning: '',
  })

  return (
    <div className="flex w-full flex-col">
      {fields.map((field) => {
        return (
          <Input
            {...field}
            key={field.name}
            value={form[field.name]}
            onChange={(e) => {
              setForm((prev) => ({ ...prev, [field.name]: e.currentTarget.value }))
            }}
          />
        )
      })}
    </div>
  )
}
